import { useQuery } from '@tanstack/react-query';
import type { CmsRecommendedLinksResponse } from '@gov-nx/api';
import { useAxiosCmsInstance } from '@gov-nx/api';
import { useAppLanguageSelector } from '@gov-nx/core/hooks';
import { useConfiguration } from '@gov-nx/core/service';
import { useCmsUrlPath } from '@gov-nx/store';

export const useCmsRecommendedLinksQuery = () => {
	const { cmsKeyCache } = useConfiguration();
	const { language } = useAppLanguageSelector();
	const { axiosCmsInstance } = useAxiosCmsInstance();
	const { baseCmsUrlPath } = useCmsUrlPath();

	const query = useQuery({
		queryFn: async () => {
			const response = await axiosCmsInstance.get<CmsRecommendedLinksResponse>(
				`/recommended-links/${language}.json?v=${cmsKeyCache}`
			);
			return response.data.data;
		},
		refetchOnWindowFocus: false,
		queryKey: ['cms-recommended-links'],
	});

	return {
		data: query.data ?? [],
		isLoading: query.isLoading,
		baseCmsUrlPath,
	};
};
